<template>
    <div>
        <Breadcrumbs main="帳號" title="我的帳號" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="edit-profile">
                <div class="row">
                    <div class="col-xl-4">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title mb-0">基本資料</h4>
                                <div class="card-options"><a class="card-options-collapse" href="#"
                                        data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a
                                        class="card-options-remove" href="#" data-toggle="card-remove"><i
                                            class="fe fe-x"></i></a></div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-2">
                                    <!-- <div class="col-auto"><img class="img-70 rounded-circle" alt=""
                                                src="../../assets/images/user/7.jpg" v-if="false"></div> -->
                                    <div class="col">
                                        <h5 class="mb-1">{{ user.displayName }}</h5>
                                        <p class="mb-4">{{ user.memberGrade }}</p>
                                    </div>
                                </div>

                                <table class="table table-bordernone form-group m-t-20 m-b-20">
                                    <tbody>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">會員有效到期日</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                2022/07/10
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">廣告有效到期日</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                2022/07/10
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">資料提交日期</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                2022/07/10
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title mb-0">登入选项</h4>
                                <div class="card-options"><a class="card-options-collapse" href="#"
                                        data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a
                                        class="card-options-remove" href="#" data-toggle="card-remove"><i
                                            class="fe fe-x"></i></a></div>
                            </div>
                            <div class="card-body">

                                <table class="table table-bordernone form-group m-t-20 m-b-20">
                                    <tbody>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">User Name</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                {{ LoginAccount }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">Email</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                {{ LoginEmail }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">Mobile</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                {{ LoginCell }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="img-content-box pl-0">
                                                <span class="d-block">Other</span>
                                                <span class="font-roboto invisible">&nbsp;</span>
                                            </td>
                                            <td class="text-right">
                                                {{ LoginOther }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title mb-0">修改密碼</h4>
                                <div class="card-options"><a class="card-options-collapse" href="#"
                                        data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a
                                        class="card-options-remove" href="#" data-toggle="card-remove"><i
                                            class="fe fe-x"></i></a></div>
                            </div>
                            <div class="card-body">
                                <p>密码至少由8个字符组成，必须包含最少一个英文字母及一个数字</p>
                                <ValidationObserver ref="updatePasswordForm">
                                    <div class="form-group">
                                        <textbox title="旧密码"
                                            :rules="{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/ }"
                                            v-model="oldPassword" type="password" name="oldPassword" ref="oldPassword">
                                        </textbox>
                                    </div>
                                    <div class="form-group">
                                        <textbox title="新密码"
                                            :rules="{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/ }"
                                            v-model="newPassword" type="password" name="password" ref="newPassword"
                                            vid="newPassword">
                                        </textbox>
                                    </div>
                                    <div class="form-group">
                                        <textbox title="重复新密码" rules="required|confirmed:newPassword"
                                            v-model="newPasswordRepeat" type="password" name="newPasswordRepeat"></textbox>
                                    </div>
                                    <div class="form-footer">
                                        <button class="btn btn-primary btn-block"
                                            @click="updatePasswordConfirmation">保存</button>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import { userService } from "../../../src/_services"

export default {
    data() {
        return {
            //Password
            oldPassword: '',
            newPassword: '',
            newPasswordRepeat: '',
            //Login Info
            LoginAccount: '',
            LoginEmail: '',
            LoginCell: '',
            LoginOther: ''
        }
    },
    mounted() {
        userService.GetLoginInfo().then(res => {
            var data = res;
            for (var i = 0; i < data.length; i++) {
                switch (data[i].type) {
                    case "password":
                        this.LoginAccount == "" ? this.LoginAccount += data[i].verifyLogin : this.LoginAccount += ", " + data[i].verifyLogin
                        break;
                    case "email":
                        this.LoginEmail == "" ? this.LoginEmail += data[i].verifyLogin : this.LoginEmail += ", " + data[i].verifyLogin
                        break;
                    case "mobile":
                        this.LoginCell == "" ? this.LoginCell += data[i].verifyLogin : this.LoginCell += ", " + data[i].verifyLogin
                        break;
                    case "other":
                        this.LoginOther == "" ? this.LoginOther += data[i].verifyLogin : this.LoginOther += ", " + data[i].verifyLogin
                        break;
                    default:
                        break;
                }
            }
        })
    },
    computed: {
        user() {
            return this.$store.state.authentication.user
        }
    },
    methods: {
        resetPasswordForm() {
            this.oldPassword = "";
            this.newPassword = "";
            this.newPasswordRepeat = "";
            this.$refs.updatePasswordForm.reset();
        },
        updatePasswordConfirmation() {
            var that = this;
            this.$refs.updatePasswordForm.validate().then(result => {
                if (result) {
                    that.$swal({
                        //Show Alert
                        text: "Are you sure to update password?",
                        showCancelButton: true,
                        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
                        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
                    }).then(() => {
                        that.updatePassword();
                    })
                }
            })
        },
        async updatePassword() {
            try {
                var res = await userService.UpdatePassword(this.oldPassword, this.newPassword);
                if (res == 1) {
                    this.$swal({
                        text: "successful",
                        buttons: false
                    })
                    this.resetPasswordForm();
                } else if (res == 2) {
                    this.$swal({
                        text: "old password is wrong",
                        buttons: false
                    })
                } else {
                    this.$swal({
                        text: "Error occur, please contact us for help",
                        buttons: false
                    })
                }
            } catch (ex) {
                this.$swal({
                    text: "Error occur, please contact us for help",
                    buttons: false
                })
            }

        }
    }
}
</script>
<style></style>